@if (bills.length > 1 && visibility) {
  <div class="modal-lines-list" id="list-wrapper" (click)="setSelectedBill(null)">
    <div id="content">
      <ul class="list-group">
        @for (bill of bills; track bill) {
          <li class="list-group-item" (click)="setSelectedBill(bill)">
            {{ bill.period }} - Facture n°{{ bill.id }} - {{ priceFormatService.getBillAmount(bill.totalTtc, bill.totalHt, bill.cusPenalityHt) }}
          </li>
        }
      </ul>
    </div>
  </div>
}
